import { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { history } from 'Store/configureStore'
import { firePageViewEvent } from 'Store/Analytics/actions'
import { normalizePagePath, shouldSkipPageView } from 'shared/utilities/pageViewUtils'

const PageViewTracker = ({ dispatch }) => {
  const lastTrackedRef = useRef(null)

  useEffect(() => {
    const track = location => {
      const pagePath = normalizePagePath(location.pathname + location.search)

      if (shouldSkipPageView(lastTrackedRef.current, pagePath)) return

      lastTrackedRef.current = pagePath
      dispatch(firePageViewEvent(pagePath))
    }

    track(history.location)

    const unlisten = history.listen(location => {
      track(location)
    })

    return unlisten
  }, [dispatch])

  return null
}

export default connect()(PageViewTracker)
